import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';

import { Context } from '../context/DataContext';

const CheckPDFPage = () => {
  const navigate = useNavigate();
  const { state, getVirtualAccountInfo, setCustomerInfo
  } = React.useContext(Context);
  const {
    customerInfo: {
      orderId,
      serviceName,
      payType,
      insuranceNo,
      fromDate,
      toDate,
      name,
      id,
      birthday,
      address,
      market_n,
      imei,
      phonePrice,
      phone,
      repairTarget,
      repairCount,
      swapPrice,
      insurancePrice,
      periodType,
    },
    loginInfo: { empName, empCode, dealerNo },
  } = state;
  const queryString = new URLSearchParams({
    order_id: orderId,
    service_name: serviceName,
    payment_type: payType,
    info_jstr: JSON.stringify({
      insurance_number: insuranceNo,
      period: `${fromDate} - ${toDate}`,
      name,
      id,
      birthday,
      address,
      model_name: market_n,
      imei,
      phone_price: phonePrice,
      phone,
      target: repairTarget,
      repair_count: repairCount,
      swap: swapPrice,
      price: insurancePrice,
      installment_price: payType === 'installment' ? insurancePrice : '',
      licenseNo: empCode,
      insuranceAgentName: empName,
      extraTerms:
        periodType === 'B' ? '安達產物行動裝置保險電池維修置換附加條款(D)' : '',
    }),
  }).toString();
  const [errorMsg, setErrorMsg] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  return (
    <Box sx={{ pb: 8 }}>
      <Typography variant='h4' sx={{ my: 2 }}>
        要保書確認
      </Typography>
      <Box>
        <embed
          style={{
            height: 'calc(100vh - 234px)',
            width: '100%',
          }}
          src={`${process.env.REACT_APP_LEAGUE_BASE_WEB_URL}/m/insurance/consent/finalview?${queryString}`}
        />
        <LoadingButton
          variant='contained'
          loading={loading}
          sx={{ width: 168 }}
          onClick={() => {
            // how to pay with api
            // payment success --> upload photos
            switch (payType) {
              case 'installment':
              case 'credit':
              case 'credit_installment':
                navigate('/tap-pay');
                break;
              case 'cash':
                if (dealerNo === '017' || dealerNo === '008') {
                  navigate('/barcode');
                } else {
                  navigate('/upload-photos');
                }
                break;
              case 'tel_bill':
                // Call check api then go to upload photos page
                navigate('/upload-photos');
                break;
              case 'virtual_account':
                // Call check api then go to upload photos page
                setLoading(true);
                getVirtualAccountInfo({ orderId, insurancePrice }, (data) => {
                  const { responseCode, responseMsg, rtnObj } = data;

                  if (responseCode === '000') {
                    const { BankId, BankName, VirtualAccount, PaymentExpireDate, ResponseCode, ResponseMSG } = rtnObj;

                    if (ResponseCode === '1') {
                      setCustomerInfo({
                        bankId: BankId,
                        bankName: BankName,
                        virtualAccount: VirtualAccount,
                        paymentExpireDate: PaymentExpireDate,
                      }, () => {
                        navigate('/bank-transfer-info');
                        setLoading(false);
                      });
                    } else {
                      setErrorMsg(ResponseMSG);
                      setLoading(false);
                    }
                  }
                  else {
                    setErrorMsg(responseMsg);
                    setLoading(false);
                  }
                });
                break;
              default:
                navigate('/upload-photos');
                break;
            }
          }}
        >
          開始繳費
        </LoadingButton>
        {errorMsg ? (
          <Typography variant="h6" sx={{ my: 2, color: 'red' }}>
            {errorMsg}
          </Typography>
        ) : null}
      </Box>
    </Box >
  );
};

export default CheckPDFPage;
